import { css } from '@emotion/react';
import { SectionTitle } from '@/components/general/SectionTitle';
import { ButtonLink } from '@/components/shared/ButtonLink';
import { FaqCard } from '@/components/top-page/FaqCard';
import { useFaqQuery } from '@/hooks/useFaqQuery';
import { pagesPath } from '@/lib/pagesPath';
import { getScreen } from '@/styles/media-query';

export type FaqSectionProps = {
  className?: string;
};

export const FaqSection: React.FC<FaqSectionProps> = ({ className }) => {
  const { items } = useFaqQuery();

  return (
    <section
      className={className}
      css={css`
        background-color: rgba(209, 216, 221, 0.28);
        padding: 64px 20px 80px;
      `}
    >
      <SectionTitle en="FAQ">
        <strong>よくあるご質問</strong>
      </SectionTitle>
      <ul
        css={css`
          display: flex;
          flex-direction: column;
          gap: 22px;
          margin-top: 36px;
          padding: 0 20px;

          @media ${getScreen('pc')} {
            gap: 42px;
            margin-top: 65px;
          }
        `}
      >
        {items.map((item) => (
          <li
            key={item.ipoServiceFaqId}
            css={css`
              margin: 0 auto;
              width: 100%;
              max-width: 934px;
            `}
          >
            <FaqCard {...item} />
          </li>
        ))}
      </ul>
      <ButtonLink
        css={css`
          margin: 64px 20px 0;

          @media ${getScreen('pc')} {
            width: 221px;
            margin: 90px auto 0;
          }
        `}
        to={pagesPath.faq.$url()}
        variant="top-more"
      >
        一覧を見る
      </ButtonLink>
    </section>
  );
};
